import { useMemo, useState } from 'react';
import './tabs.css';
import { ITabsData } from '../../types/type';

function Tab({ component: Component, style }: ITabsData) {
  return (
    <div className="tabs__content" style={Component ? { marginBottom: '250px' } : undefined}>
      <div style={typeof style === 'object' ? style : undefined}>{Component}</div>
    </div>
  );
}

interface TabsProps {
  tabsData: ITabsData[];
  containerClass?: string;
  fio?: string;
}

function Tabs({ tabsData, containerClass, fio }: TabsProps) {
  const [activeTab, setActiveTab] = useState(0);

  const activeComponent = useMemo(() => {
    if (!tabsData[activeTab]?.component) return null;
    return <Tab component={tabsData[activeTab].component} style={tabsData[activeTab].style} />;
  }, [tabsData, activeTab]);

  return (
    <div className={`tabs ${containerClass || ''}`}>
      <div className="tabs__nav">
        {tabsData.map((item, idx) => (
          <button
            key={idx}
            onClick={() => setActiveTab(idx)}
            className={`tabs__item ${activeTab === idx ? 'tabs__item__active' : ''}`}
          >
            {item.title}
          </button>
        ))}
        {fio ? <li className="tabnav__fio">{fio}</li> : ''}
      </div>
      {activeComponent}
    </div>
  );
}

export default Tabs;
